<p-toast></p-toast>
<div class="content bg-design">
  <app-header *ngIf="isShow"></app-header>
  <div class="div">
    <router-outlet></router-outlet>
  </div>
</div>
